import {Injectable, Signal} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import {Apollo} from 'apollo-angular';
import {GET_USER_PROFILE} from '../queries-repository';
import {Query, UserProfilePayload} from '../types-repository';
import {Observable, switchMap} from 'rxjs';
import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';


@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  private up: Observable<UserProfilePayload>

  readonly staff: Signal<boolean>;
  readonly name: Signal<string | undefined>;
  readonly email: Signal<string | undefined>;


  constructor(oauthService: OAuthService, apollo: Apollo) {
    this.up = oauthService.events.pipe(
      startWith({type: 'dummy_event'}),
      filter((event: OAuthEvent) => oauthService.hasValidAccessToken()),
      switchMap(event => {
        return apollo.query<Query>({
          query: GET_USER_PROFILE
        }).pipe(
          filter(res => !!res.data?.userProfile),
          map(res => res.data.userProfile),
        );
      }),
      shareReplay(1)
    )

    this.staff = toSignal(this.up.pipe(map(up => up.staff)), {initialValue: false});
    this.name = toSignal(this.up.pipe(map(up => up.name)));
    this.email = toSignal(this.up.pipe(map(up => up.email)));
  }
}
